import React from 'react';
import { Shield, Heart, User, Users } from 'lucide-react';
import { specialties } from '../mockData';
import { Card, CardContent } from './ui/card';

const iconMap = {
  Shield: Shield,
  Heart: Heart,
  User: User,
  Users: Users
};

const gradients = [
  'from-cyan-500 to-blue-500',
  'from-purple-500 to-pink-500',
  'from-blue-500 to-indigo-500',
  'from-teal-500 to-emerald-500'
];

const bgGradients = [
  'from-cyan-50 to-blue-50',
  'from-purple-50 to-pink-50',
  'from-blue-50 to-indigo-50',
  'from-teal-50 to-emerald-50'
];

const Specialties = () => {
  return (
    <section id="specialties" className="py-20 bg-gradient-to-br from-white via-purple-50/30 to-cyan-50/30 relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute top-10 left-10 w-40 h-40 bg-gradient-to-br from-cyan-300/20 to-blue-300/20 rounded-full blur-2xl"></div>
      <div className="absolute bottom-10 right-10 w-60 h-60 bg-gradient-to-br from-purple-300/20 to-pink-300/20 rounded-full blur-2xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <span className="text-transparent bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text font-bold text-sm uppercase tracking-wider">Medical Specialties</span>
          <h2 className="text-5xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-purple-900 bg-clip-text text-transparent mt-2">Areas of Expertise</h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto text-lg">
            Comprehensive care across multiple medical disciplines
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {specialties.map((specialty, index) => {
            const IconComponent = iconMap[specialty.icon];
            return (
              <Card key={specialty.id} className={`border-none shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 hover:-translate-y-2 bg-gradient-to-br ${bgGradients[index]}`}>
                <CardContent className="p-6 text-center space-y-4">
                  <div className={`bg-gradient-to-br ${gradients[index]} w-20 h-20 rounded-2xl flex items-center justify-center mx-auto shadow-lg transform hover:rotate-12 transition-transform duration-300`}>
                    <IconComponent className="h-10 w-10 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">{specialty.title}</h3>
                  <p className="text-gray-700">{specialty.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Specialties;